/** @jsx jsx */
import React, { FC } from "react";
import { jsx } from "@emotion/react";
import { CellEntity } from "src/components/organisms/ColumnTemplatePositionEditor/types";

import {
  DelimiterPatternIds,
  DELIMITER_PATTERNS,
} from "src/requests/templates/types";
import * as S from "./styles";

interface DelimiterEntityType {
  delimiterPatternId: DelimiterPatternIds;
}

const DelimiterEntity: FC<DelimiterEntityType> = ({ delimiterPatternId }) => {
  if (delimiterPatternId === DelimiterPatternIds.EMPTY) return null;

  const { pattern, position } = DELIMITER_PATTERNS[delimiterPatternId];

  return (
    <div css={S.delimiterContainerCss(pattern, position)}>
      <div />
    </div>
  );
};

export default DelimiterEntity;
